import RpcMethodType from '@jbrowse/core/pluggableElementTypes/RpcMethodType';
import { renameRegionsIfNeeded } from '@jbrowse/core/util';
// specialized get features to return limited data about alignments
export default class PileupBaseRPC extends RpcMethodType {
    async serializeArguments(args, rpcDriver) {
        var _a;
        const { rootModel } = this.pluginManager;
        const assemblyManager = (_a = rootModel === null || rootModel === void 0 ? void 0 : rootModel.session) === null || _a === void 0 ? void 0 : _a.assemblyManager;
        if (!assemblyManager) {
            throw new Error('no assembly manager available');
        }
        const renamedArgs = await renameRegionsIfNeeded(assemblyManager, args);
        return super.serializeArguments(renamedArgs, rpcDriver);
    }
}
